module.exports = __webpack_public_path__ + "static/media/logo-tower.9eaea195.svg";